import { Asterisk } from "lucide-react";
import { CERTS } from "./data";

const Row = () => (
  <div className="flex shrink-0 items-center">
    {CERTS.map((c, i) => (
      <span key={c} className="flex items-center">
        <span className={`px-8 whitespace-nowrap text-5xl sm:text-7xl lg:text-8xl ${i % 2 ? "font-serif-i text-slate-200" : "font-display font-bold text-outline"}`}>{c}</span>
        <Asterisk className="text-cyan-300 shrink-0" size={36} />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="relative border-y border-white/10 py-10 sm:py-14 overflow-hidden" data-testid="certifications-marquee" aria-label="Certifications">
    <p className="mx-auto max-w-[1400px] px-5 sm:px-8 mb-8 font-mono text-[11px] uppercase tracking-[0.28em] text-slate-500">Certified &amp; experienced across</p>
    <div className="flex marquee-track">
      <Row />
      <Row />
    </div>
  </section>
);
